<template>
  <div class="login-wrap">
    <el-card class="login-card">
      <div slot="header">管理后台登录</div>
      <el-form :model="form" @submit.native.prevent="submit">
        <el-form-item label="账号">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" type="password" show-password @keyup.enter.native="submit"></el-input>
        </el-form-item>
        <el-button type="primary" :loading="loading" style="width:100%" @click="submit">登录</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { login } from '../api'

export default {
  name: 'Login',
  data() {
    return { form: { username: '', password: '' }, loading: false }
  },
  methods: {
    submit() {
      this.loading = true
      login(this.form).then((data) => {
        localStorage.setItem('admin_token', data.token)
        localStorage.setItem('admin_name', data.nickname)
        this.$router.replace('/')
      }).catch((e) => {
        this.$message.error(e.message)
      }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>
